import React, { useState, Fragment } from "react";
import { UserTypes } from '../../constants';
import { TempPasswordGeneratorBlock } from './TempPasswordGeneratorBlock';
//import { FaSortUp, FaSortDown } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt, FaFileUpload
//import { IconContext } from "react-icons";

export const UsersTable = ({ users, deleteUser, deleteUsers, teamId, setReceivedError }) => {
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [activeTeamUserId, setActiveTeamUserId] = useState(null);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedUsers(users.map(user => user.id));
        } else {
            setSelectedUsers([]);
        }
    };

    const handleSelectUser = (e, userId) => {
        if (e.target.checked) {
            setSelectedUsers([...selectedUsers, userId]);
        } else {
            setSelectedUsers(selectedUsers.filter(id => id !== userId));
        }
    };

    const handleDeleteUser = async (user) => {
        await deleteUser(user);
        setSelectedUsers(selectedUsers.filter(id => id !== user.id));
    };

    const handleDeleteUsers = async (userIds) => {
        if (window.confirm(`Remove selected ${userIds.length > 1 ? 'users' : 'user'} completely?`)) {
            await deleteUsers(userIds);
            setSelectedUsers(selectedUsers.filter(id => !userIds.includes(id)));
        }
    };

    return (
        <>
            <table className="Table">
                <thead>
                    <tr className="TableBlock">
                        <th key="select" className="TableFirstLineBlock">Select</th>
                        <th key="email" className="TableFirstLineBlock">Email</th>
                        <th key="name" className="TableFirstLineBlock">Name</th>
                        <th key="progress" className="TableFirstLineBlock">Progress</th>
                        <th key="content" className="TableFirstLineBlock">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {users?.length ? (
                        users
                            .map((user, index, array) => {
                                return (
                                    <Fragment key={user.id}>
                                        <tr>
                                            <td className='TableSecondLineBlock text-center text-white'>
                                                <input
                                                    type="checkbox"
                                                    className="checkbox-lg"
                                                    checked={selectedUsers.includes(user.id)} 
                                                    onChange={(e) => handleSelectUser(e, user.id)}
                                                />
                                            </td>
                                            <td className='TableSecondLineBlock text-center text-white'>
                                                {user.email} {user.type === UserTypes.Team ? '(Team)' : ''}
                                            </td>
                                            <td className='TableSecondLineBlock text-center text-white'>
                                                {user.nickname ? user.nickname : '---'}
                                            </td>
                                            <td className='TableSecondLineBlock text-center text-white'>
                                                {user.progress ? `${Number(user.progress).toFixed(2)}%` : '---'}
                                            </td>
                                            <td className="TableSecondLineBlock text-center">
                                                {user.type === UserTypes.Team ? (
                                                    <img
                                                        src="/img/Eye.png"
                                                        onClick={() => setActiveTeamUserId(activeTeamUserId === user.id ? null : user.id)}
                                                        alt="" className="mx-1 TableSecondLineImg"
                                                    />
                                                ) : null}
                                                <img
                                                    src="/img/TrashB.png"
                                                    alt="" onClick={() => {
                                                        if (window.confirm("Remove this user completely?")) {
                                                            handleDeleteUser(user);
                                                        }
                                                    }}
                                                    className="text-danger mx-1 TableSecondLineImg"
                                                />
                                            </td>
                                        </tr>
                                        {activeTeamUserId === user.id ? (
                                            <tr key={-1}>
                                                <td colSpan={5} className="p-3">
                                                    <TempPasswordGeneratorBlock user={user} setReceivedError={setReceivedError} />
                                                </td>
                                            </tr>
                                        ) : null}
                                    </Fragment>
                                );
                            })
                    ) : (
                        <tr className="NoElementsText"><td colSpan={5} className="text-center">No Users</td></tr>
                    )}
                </tbody>
            </table >

            {users.length > 0 ?
                <div className='ml-3 mt-3 text-white'>
                    <input
                        id={`select-all-${teamId}`}
                        type="checkbox"
                        className="checkbox-lg"
                        checked={selectedUsers.length === users.length && users.length !== 0}
                        onChange={handleSelectAll}
                    />
                    <label htmlFor={`select-all-${teamId}`} className="pl-2 mb-0">Select all</label>
                    <button
                        disabled={selectedUsers.length === 0}
                        className='btn btn-info btn-sm ml-3'
                        onClick={() => handleDeleteUsers(selectedUsers)}>
                        Delete Users
                    </button>
                    {/*<button className='btn btn-info btn-sm ml-3'
                        onClick={() => { console.log('send emails not implemented') }}>Move users</button>
                    <button className='btn btn-info btn-sm ml-3'
                        onClick={() => { console.log('send emails not implemented') }}>Reset Passwords</button>*/}
                </div>
                :
                null}
        </>
    )
};
